/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import React from "react";
import { Navigate, useLocation } from "react-router-dom";

/**
 * A redirect that keeps the query string and fragment of the address it
 * replaces (Session 515 review, SU-2: /app-privacy-policy?from=store lands on
 * /privacy-policy?from=store, as the server's redirect does).
 */
const RedirectKeepingQuery: React.FC<{ to: string }> = ({ to }) => {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: to, search, hash }} replace />;
};

export default RedirectKeepingQuery;
